import * as types from './authActionTypes.js';

const authReducer = (state, action) => {
  switch (action.type) {
    case types.AUTH_START:
      return {
        ...state,
        error: false,
        loading: true
      };

    case types.AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        token:              action.payload?.token ?? action.payload,
        subscriptionStatus: action.payload?.subscriptionStatus ?? state.subscriptionStatus ?? 'active',
        subscriptionCode:   action.payload?.subscriptionCode   ?? state.subscriptionCode   ?? null,
      };

    case types.AUTH_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errResponse: action.payload
      };

    case types.AUTH_RESET:
      return {
        ...state,
        loading: false,
        error: false,
        errResponse: '',
        token: null,
        user: null
      };

    default:
      return state;
  }
};

export default authReducer;